export const ACTION = '/WishListLines/GetWishList';

export const ACTION_WITH_USER_ID = '/WishListLines/GetWishListByUserId';

export const ACTION_REMOVE_WISH_LIST = '/WishListLines/RemoveWishListLines';

export const ACTION_ADD_WISH_LIST = '/WishListLines/AddWishListLine';
